import React, { lazy, Suspense } from 'react'
import { Switch, Route } from 'react-router-dom'
import AccountHome from 'AccountsContainers/AccountHome'
import TripListAll from 'AccountsContainers/Trips/TripListAll'
import {
  LOAD_TRIP_DETAILS,
  LOAD_HOME,
  LOAD_TRIP_LIST,
  LOAD_CANCELLATION,
  TRIP_NOT_FOUND,
  ROUTER_BASE_PATH
} from 'AccountsConstants/routes'
// import Cancellation from 'AccountsContainers/Trips/Cancellation'
import PageLoader from 'Lib/Pageloader'
import PageNotFound from './containers/PageNotFound'
import MobileDeviceSupport from './components/Support/MobileDeviceSupport'
import TripNotFound from './containers/TripNotFound'

const TripDetails = lazy(() => import('./pages/Trips/TripDetails'))
const Cancellation = lazy(() => import('./containers/Trips/Cancellation'))

const basePrepend = path => `${ROUTER_BASE_PATH}${path}`
// const routes = [
//   { path: basePrepend(LOAD_HOME), exact: true, lazy: false, component: AccountHome },
//   { path: basePrepend(LOAD_TRIP_LIST), exact: true, lazy: false, component: TripListAll },
//   { path: basePrepend(LOAD_TRIP_DETAILS), exact: true, lazy: true, component: TripDetails },
//   { path: basePrepend(TRIP_NOT_FOUND), exact: true, lazy: false, component: TripNotFound },
//   { path: basePrepend(LOAD_CANCELLATION), exact: true, lazy: true, component: Cancellation },
//   { path: basePrepend('/contactUs'), exact: true, lazy: false, component: MobileDeviceSupport },
//   { path: '*', exact: false, component: PageNotFound }]
const router = ({ match }) => (
  <Switch>
    <Route
      exact={true}
      path={basePrepend(LOAD_HOME)}
      render={routeProps => (
        <AccountHome match={match} isPWA={true} {...routeProps} />
      )}
    />
    <Route
      exact={true}
      path={basePrepend(LOAD_TRIP_LIST)}
      render={routeProps => (
        <TripListAll match={match} isPWA={true} {...routeProps} />
      )}
    />
    <Route
      exact={true}
      path={basePrepend(LOAD_TRIP_DETAILS)}
      render={routeProps => (
        <Suspense fallback={(<PageLoader title="Loading..." message="Please wait..." />)}>
          <TripDetails match={match} isPWA={true} {...routeProps} />
        </Suspense>
      )}
    />
    <Route
      exact={true}
      path={basePrepend('/contactUs')}
      component={MobileDeviceSupport}
    />
    <Route
      exact={true}
      path={basePrepend(LOAD_CANCELLATION)}
      render={routeProps => (
        <Suspense fallback={(<PageLoader title="Loading..." message=" " />)}>
          <Cancellation match={match} isPWA={true} {...routeProps} />
        </Suspense>
      )}
    />
    <Route
      exact={true}
      path={basePrepend(TRIP_NOT_FOUND)}
      render={routeProps => (
        <TripNotFound match={match} isPWA={false} {...routeProps} />
      )}
    />
    <Route
      path="*"
      render={routeProps => (
        <PageNotFound match={match} isPWA={true} {...routeProps} />
      )}
    />
  </Switch>
)

export default router

// <Switch>
//   {routes.map(route => (
//     <If condition={!route.lazy}>
//       <Route
//         exact={route.exact}
//         path={route.path}
//         render={routeProps => <route.component match={match} isPWA={true} {...routeProps} />}
//       />
//       <Else />
//       <Suspense fallback={(<PageLoader title="Loading..." message=" " />)}>
//         <Route
//           exact={route.exact}
//           path={route.path}
//           render={routeProps => <route.component match={match} isPWA={true} {...routeProps} />}
//         />
//       </Suspense>
//     </If>
//   )
//   )}
// </Switch>
